class ApplicationMenu {
  constructor() {
    this.containerId = 'application-menu-container';
    const hamburger = document.querySelector('.hamburger-wrapper');
    this.clear();
    this.handleContainer();
    this.handelGestures();

    $('#collapse-mobile-page-action').on('click', function(ev) {
      if (ev.target.classList.contains('menu-dropdown')) {
        $(this).collapse('hide')
      }
    });

    !!hamburger && hamburger.addEventListener('click', (ev) => {
      ev.preventDefault();

      document.querySelector('html').classList.toggle('open-menu', true);
    });

    document.querySelectorAll('.tr-header .top-menu .nav-item.sub-items .sub-nav a.nav-link').forEach((el) => {
      el.addEventListener('click', (ev) => {
        this.clear();
      });
    });

    document.querySelectorAll('.tr-header .top-menu .nav-item > a, .tr-header .actions .nav-item > a').forEach((el) => {
      el.addEventListener('click', (ev) => {
        const li = ev.currentTarget.closest('li');
        if (li.querySelectorAll('ul.sub-nav').length == 0) {
          return;
        }

        ev.preventDefault();

        if (li.classList.contains('hover')) {
          this.closeMenu(li);
          return;
        }

        this.clear();

        li.classList.toggle('hover', true);
        document.querySelector('html').classList.toggle('open-menu', true);
      });
    });
  }

  handleContainer() {
    const container = document.getElementById(this.containerId);

    if (!container)
      return;

    container.addEventListener('click', () => {
      document.querySelector('html').classList.toggle('open-menu', false);

      const li = document.querySelector('.tr-header .nav-item.hover');

      if (!li)
        return;

      this.closeMenu(li);
    });
  }

  closeMenu(li) {
    li.classList.toggle('hover', false);
  }

  clear() {
    document.querySelectorAll('.tr-header .nav-item').forEach((li) => {
      li.classList.remove('hover');
    });

    document.querySelector('html').classList.toggle('open-menu', false);
  }

  handelGestures() {
    let mobilePageActions = document.querySelector('.mobile-page-actions ul.dropdown-page-action');

    if (!mobilePageActions) return;

    var hammertime = new Hammer(mobilePageActions, {
      recognizers: [
        [Hammer.Swipe,{ direction: Hammer.DIRECTION_DOWN }]
      ]
    });
    hammertime.on('swipe', function(ev) {
      $(document.getElementById('collapse-mobile-page-action')).collapse('toggle');
    });
  }
}

document.addEventListener("turbo:load", () => new ApplicationMenu());